<template>
	<div class="books">
		<div class="list">
			<div class="list-div" v-for="(item,index) in list" :key="index">
				<div class="title">{{item.name}}</div>
				<div class="connet">
					<div class="left">
						<img :src="item.img" />
					</div>
					<div class="right">
						<div class="right-div">{{item.brief}}</div>
						<div class="right-div1">
							<div>购买链接：</div>
							<a :href="item.dang_url">
								<img src="../../assets/shudo/images/dang.png" />
							</a>
							<a :href="item.jin_url">
								<img src="../../assets/shudo/images/jing.png">
							</a>
							<a :href="item.tao_url">
								<img src="../../assets/shudo/images/tao.png" />
							</a>
							<a :href="item.mao_url">
								<img src="../../assets/shudo/images/tian.png" />
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	    data() {
			return {
				list : [],
				merchant_id:''
			}
	    },
		created() {
			let that = this;
			var  query = that.$route.query;
			if(query.merchanthot_id){
				that.merchant_id = query.merchanthot_id;
				
				that.$http('get','/api/v1/books/merchantlist',{'merchant_id':that.merchant_id}) .then(function (res) {
					console.log(res);
					that.list = res.data.list;
					
				});
				
			}
		},
	
	}
</script>

<style lang="less">
	.books {
		width: 100%;
		.list {
			width: 80%;
			min-height: 30rem;
			margin: auto;
			.list-div {
				margin: 30px;
				width: 80%;
				height: 230px;
				border-bottom: 0.0625rem solid #b0a6a6;
				.title {
					font-size: 1.4rem;
					height: 2.3125rem;
					box-shadow: none;
					font-family: "Arial Negreta", "Arial Normal", Arial;
					font-weight: 700;
					font-style: normal;
				}
				.connet {
					margin-top: 1.25rem;
					width: 100%;
					display: flex;
					.left {
						width: 252px;
						height: 148px;
						img {
							width: 100%;
							height: 100%;
						}
					}
					.right {
						margin-left: 0.625rem;
						.right-div {
							font-size: 1.2rem;
							height: 5.625rem;
						}
						.right-div1 {
							font-size: 1.2rem;
							font-weight: 600;
							display: flex;
							div {
								width: 7.5rem;
							}
							img {
								width: 5.4375rem;
								height: 2.5rem;
								margin-left: 0.625rem;
								margin-right: 0.625rem;
							}
						}
					}
					
					
				}
			}
			
		}
	}
</style>
